Label = require 'app/scripts/models/label'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
l = require 'app/scripts/lib/localize'

module.exports = class LabelEditComponent extends View
  tagName: 'form'
  className: 'edit-label'
  events:
    'click .js-palette-color': 'pickColor'
    'click .js-submit': 'submit'
    'submit': 'submit'

  initialize: ({ @accessoryView, @color, @onSubmit, @submitTextKey }) -> super

  renderOnce: ->
    colors = for color in Label.colors
      { color, selected: color == @color }
    data = { label: { name: @model.name }, colors }
    data.submitText = l(@submitTextKey)
    data.noColor = @color == null
    @$el.html(templates.fill(require('app/scripts/views/templates/label_edit_component'), data))

    if @accessoryView?
      @$('.js-accessory-view-holder').append(@accessoryView.render().el)

    @

  pickColor: (e) ->
    Util.stop(e)
    @$('.js-palette-select').hide()
    $color = @$(e.target).closest('.js-palette-color')
    @color = $color.attr('data-color')
    $color.find('.js-palette-select').show()

  submit: (e) ->
    Util.stop(e)
    name = @$('.js-label-name').val().trim()
    if _.isEmpty(name) && _.isEmpty(@color)
      return
    else
      @onSubmit name, (if _.isEmpty(@color) then null else @color)
